export const SURVEY_REQUEST = 'survey/SURVEY_REQUEST';
export const SURVEY_SUCCESS = 'survey/SURVEY_SUCCESS';